(ns app.api-credential.page
  "API Credential management page. An agent's credential (made with
   the agent, `app.agent.storrito-connection`) is listed with the
   agent's name and without a Delete button: it goes with the agent,
   on the Agents page."
  (:require [storrito.ui.core :as ui]
            [storrito.ui.table :as ui-table]
            [parts.replicant.query :as query]
            [ui.app-frame :as app-frame]))

(def api-credentials-query
  {:query/kind :query/api-credentials})

(defn agent-credential?
  [credential]
  (some? (:api-credential/sprite-name credential)))

(defn name-cell
  "The credential's name: an agent's, with a mark that it is the
   agent's; a person's has none."
  [credential]
  (if (agent-credential? credential)
    [:span.inline-flex.items-center.gap-2
     (:api-credential/name credential)
     [:span {:class ["inline-flex" "items-center" "rounded-md" "bg-indigo-50" "px-2" "py-1"
                     "text-xs" "font-medium" "text-indigo-700" "ring-1" "ring-inset" "ring-indigo-700/10"]}
      "Agent"]]
    [:span.text-gray-500 "—"]))

(defn delete-cell
  "The Delete button of a person's credential; an agent's shows where
   it goes instead."
  [credential]
  (if (agent-credential? credential)
    [:span.text-sm.text-gray-500
     "Deleted with the agent"]
    (let [command {:command/kind :command/api-credential-delete
                   :command/data {:api-credential/id
                                  (:api-credential/id credential)}}
          command-action [:data/command
                          command
                          {:on-success [[:data/query api-credentials-query]]
                           :on-error [[:ui/show-error]]}]]
      [:button
       {:class ui/a-indigo
        :on {:click [[:js/confirm
                      "Are you sure? This will disconnect all clients that use this API credential."]
                     command-action]}}
       "Delete"])))

(defn table
  [state]
  (let [result (query/get-result state api-credentials-query)
        credentials (:api-credentials result)]
    [:table
     {:class ui-table/table}
     [:thead {:class ui-table/thead}
      [:tr
       [:th {:scope "col" :class ui-table/th} "Id"]
       [:th {:scope "col" :class ui-table/th} "Name"]
       [:th {:scope "col" :class ui-table/th}]]]
     [:tbody {:class ui-table/tbody}
      (if (seq credentials)
        (map
          (fn [credential]
            [:tr {:class ui-table/tr
                  :replicant/key (:api-credential/id credential)}
             [:td {:class (concat ui-table/td ["font-medium"])}
              (:api-credential/id credential)]
             [:td {:class ui-table/td}
              (name-cell credential)]
             [:td {:class ui-table/td}
              [:div.flex.justify-end
               (delete-cell credential)]]])
          credentials)
        [:tr {:class ui-table/tr}
         [:td {:colSpan 3
               :class (concat ui-table/td ["font-medium"])}
          "No API credentials yet. Create one with the button above."]])]]))

(defn panel
  [state]
  [:div
   [:div
    {:class "sm:flex sm:items-center"}
    [:div
     {:class "sm:flex-auto"}
     [:h1 {:class ui/h2}
      "API Credentials"]
     [:p.mt-2.text-gray-700
      "An API credential allows you to automate your account with the help of our "
      [:a {:class ui/a-indigo
           :href "/documentation/api/v1/"
           :target "_blank"}
       "API"]]]
    [:div
     {:class "mt-4 sm:ml-16 sm:mt-0"}
     [:button
      {:class ui/button-primary
       :on {:click [[:ui/modal-open
                     :modal/api-credential-create
                     {}]]}}
      "Create new API credential"]]]
   [:div
    {:class "mt-8 flow-root"}
    [:div
     {:class "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"}
     [:div
      {:class "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8"}
      [:div {:class ui/box}
       (table state)]]]]])

(defn render [state]
  (app-frame/app-frame
    state
    (panel state)))

(def page
  {:page-id :pages/api-credentials
   :route [["ui" "api-credential" "manage"]]
   :on-load (fn [_]
              [[:data/query api-credentials-query]])
   :render #'render})
